module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_PL-74267c6fd438be6b87c08c24f8a95388.svg";